import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import styles from './WpAuthorReco.module.less';

import { CONTEXT } from '../../config';
import { getUrlByTargetContent } from '../../utils/utils';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import { logging, logPostInfo } from '../../actions/log';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const series = {
  '8': {
    small: [1, 6],
    small_space: [2, 3, 7, 8],
    big: [4],
    big_space: [5],
    pageSize: row => {
      return parseInt(row / 3) * 8 + (row % 3 === 1 ? 3 : row % 3 === 2 ? 5 : 0);
    },
  },
  '10': {
    small: [1, 7],
    small_space: [2, 3, 4, 8, 9, 10],
    big: [5],
    big_space: [6],
    pageSize: row => {
      return parseInt(row / 3) * 10 + (row % 3 === 1 ? 4 : row % 3 === 2 ? 6 : 0);
    },
  },
  '13': {
    small: [1, 9],
    small_space: [2, 3, 4, 5, 10, 11, 12, 13],
    big: [6],
    big_space: [7, 8],
    pageSize: row => {
      return parseInt(row / 3) * 13 + (row % 3 === 1 ? 5 : row % 3 === 2 ? 8 : 0);
    },
  },
  '16': {
    small: [1, 1],
    small_space: [2, 3, 4, 5, 6, 12, 13, 14, 15, 16],
    big: [7],
    big_space: [8, 9, 10],
    pageSize: row => {
      return parseInt(row / 3) * 16 + (row % 3 === 1 ? 6 : row % 3 === 2 ? 10 : 0);
    },
  },
};
export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const [showAuthor, setShowAuthor] = useState([]);
  const [showNumber, setShowNumber] = useState(8);

  const LOG_ACTION_SOURCE = {
    action_author: `C_${logInfo?.clTag ?? logInfo.tag}_AuthorMark`,
    action_more: `C_${logInfo?.clTag ?? 'Wallpaper'}_Group_More`,
    source: `${logInfo.tag}_Author`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  const [refDom, inViewDom] = useInView({
    threshold: 0,
    initialInView: true,
    rootMargin: '600px 0px 600px 0px',
    root: data?.node,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
      });
    }
  }, [inView]);

  const getClassType = useCallback(
    index => {
      const pos = (index + 1) % parseInt(showNumber);
      if (series[showNumber].small.indexOf(pos) > -1) {
        return 'small';
      }
      if (series[showNumber].small_space.indexOf(pos) > -1) {
        return 'small_space';
      }
      if (series[showNumber].big.indexOf(pos) > -1) {
        return 'big';
      }
      if (series[showNumber].big_space.indexOf(pos) > -1) {
        return 'big_space';
      }
    },
    [showNumber],
  );

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.dataList && data.dataList.length > 0) {
      // 3 2 3的展示规则，计算显示的壁纸张数
      const pageSize = 3;
      if (
        data.dataList &&
        data.dataList[0] &&
        data.dataList[0].wallpaperList &&
        data.dataList[0].wallpaperList.length >= pageSize
      ) {
        setShowAuthor(data.dataList);
      }
    }
  }, [dispatch, data]);

  // 监听浏览器大小变化自动适应
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(e => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    if (clientWidth < 1330) {
      setShowNumber(8);
    } else if (clientWidth >= 1330 && clientWidth < 1600) {
      setShowNumber(10);
    } else if (clientWidth >= 1600 && clientWidth < 1870) {
      setShowNumber(13);
    } else if (clientWidth >= 1870) {
      setShowNumber(16);
    }
  }, []);

  const handleAuthor = useCallback(author => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: LOG_ACTION_SOURCE.action_author,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}||${author.pageCardContentId}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId: author.authorId,
          authorName: author.authorName,
        },
      }),
    );

    dispatch(
      logPostInfo({
        source_p: `${LOG_ACTION_SOURCE.source}||${author.pageCardContentId}`,
        source_pp: logInfoData.source_p,
      }),
    );

    setTimeout(() => {
      history.push(`${CONTEXT}/wpauthordetail?authorId=${author.authorId}`);
    }, 20);
  });
  const handleAuthorMore = useCallback(author => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: LOG_ACTION_SOURCE.action_more,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}||${author.pageCardContentId}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          code: author.authorId,
          title: data.title,
        },
      }),
    );

    if (data.targetType === '1' || data.targetType === '3' || data.targetType === '11') {
      dispatch(
        logPostInfo({
          source_p: `${LOG_ACTION_SOURCE.source}||${author.pageCardContentId}`,
          source_pp: logInfoData.source_p,
        }),
      );
      if (data.targetType === '11' && data.targetContent) {
        const url = getUrlByTargetContent(data);
        history.push(url);
      } else {
        history.push(`${CONTEXT}/wpauthordetail?authorId=${author.authorId}`);
      }
    } else if (data.targetType === '2' && data.targetUrl) {
      window.open(data.targetUrl);
    }
  }, []);

  return showAuthor && showAuthor.length > 0 ? (
    <div
      className={` ${styles.card_box} ${inViewDom ? styles.card_cardIn : styles.card_cardOut} `}
      ref={ref}
    >
      <div className={styles.card} ref={refDom}>
        {
          <>
            <div className={styles.card_header}>
              <div className={styles.card_header_title}>{data.title}</div>
            </div>
            {showAuthor.map((author, i) => (
              <React.Fragment key={i}>
                <div className={styles.card_author}>
                  <img
                    className={styles.card_author_head}
                    src={author.headPortrait}
                    onClick={() => {
                      handleAuthor(author);
                    }}
                  />
                  <div className={styles.card_author_infos}>
                    <div className={styles.card_author_info}>
                      <div
                        className={styles.card_author_name}
                        onClick={() => {
                          handleAuthor(author);
                        }}
                      >
                        {author.authorName}
                      </div>
                      <div
                        className={styles.card_author_numcol}
                        onClick={() => {
                          handleAuthor(author);
                        }}
                      >
                        {author.wallpaperCount} 作品{' '}
                      </div>
                      <div
                        className={styles.card_author_numcol}
                        onClick={() => {
                          handleAuthor(author);
                        }}
                      >
                        {author.collectCount} 收藏{' '}
                      </div>
                    </div>
                    <div
                      className={styles.card_author_desc}
                      onClick={() => {
                        handleAuthor(author);
                      }}
                    >
                      {author.authorDesc}
                    </div>
                  </div>
                  <div
                    className={styles.card_header_opt}
                    onClick={() => {
                      handleAuthorMore(author);
                    }}
                  >
                    查看更多
                  </div>
                </div>
                <div className={styles.card_wplist}>
                  {author.wallpaperList &&
                    author.wallpaperList
                      .slice(0, series[showNumber].pageSize(1))
                      .map((item, index) => {
                        return (
                          <WallpaperCard
                            wallpaper={item}
                            key={index}
                            cardInfo={{
                              pageSource: 'authorDetail',
                              authorId: author.authorId,
                              classType: getClassType(index),
                              isCollect: true,
                              isWallpaper: true,
                              isDeleteColl: false,
                              isDeleteUsed: false,
                              isPreview: true,
                            }}
                            logInfo={{
                              source: `${LOG_ACTION_SOURCE.source}||${author.pageCardContentId}`,
                            }}
                            virtualScroll={true}
                            triggerOnce={true}
                          />
                        );
                      })}
                </div>
              </React.Fragment>
            ))}
          </>
        }
      </div>
    </div>
  ) : (
    ''
  );
});
